import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    marginTop: 21,
  },
  contentContainerStyle: {
    paddingTop: 21,
  },
  headerStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderBottomWidth: 0,
  }),
  card: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6.3,
    shadowColor: Colors.linegrey,
    shadowOpacity: 1,
    shadowOffset: { height: 2 },
    shadowRadius: 8,
    elevation: 4,
    marginRight: 15.3,
    marginLeft: 16.7,
  }),
  firstCardStyle: {
    paddingTop: 12,
    paddingBottom: 18,
  },
  secondCardStyle: {
    paddingTop: 10,
    paddingBottom: 1,
    paddingLeft: 16,
    marginTop: 16,
  },
  buttonsSectionContainer: {
    marginTop: 16,
  },
  lottieStyle: { width: 200, height: 200 },
});
